import $ from 'jquery';
// select2 extends jQuery's prototype. Import it here, in the same bundle that owns the
// global jQuery instance, so $.fn.select2 is available to the app-wide `$` (the select2
// helpers call $('#el').select2() against window.$). This is a side-effect import: under
// webpack's AMD handling, select2's factory runs at import and registers $.fn.select2 on
// the jQuery resolved above via dependency injection (no dependency on the window globals
// set below). Do NOT call the default export -- under AMD it is the Select2 class, and
// invoking it runs the constructor with no element.
import 'select2';

window.$ = $;
window.jQuery = $;
